import { useState } from 'react';
import { iconSrc } from './format';

// Server icon from the node (checked path), or the initials of the name
export function initials(name) {
  const words = String(name || '?').trim().split(/\s+/).filter(Boolean);
  return (words.length > 1 ? words.slice(0, 3).map(w => [...w][0]).join('') : [...(words[0] || '?')].slice(0, 2).join('')).toUpperCase();
}

export default function ServerIcon({ node, icon, name, size = 48, className = '', muted = false }) {
  const [failed, setFailed] = useState(false);
  const src = !failed && iconSrc(node, icon);
  const style = { width: size, height: size, filter: muted ? 'grayscale(1) opacity(0.5)' : undefined };
  if (src) {
    return (
      <img
        src={src}
        alt=""
        draggable={false}
        onError={() => setFailed(true)}
        referrerPolicy="no-referrer"
        className={`block shrink-0 object-cover ${className}`}
        style={style}
      />
    );
  }
  return (
    <span
      className={`flex shrink-0 select-none items-center justify-center overflow-hidden bg-surface-2 font-display font-extrabold text-text ${className}`}
      style={{ ...style, fontSize: Math.max(11, Math.round(size * 0.32)) }}
    >
      {initials(name)}
    </span>
  );
}
